import axios from 'axios';

const client = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3000/api/v1',
  timeout: 30000  // 30s statt 120s — schnelleres Feedback bei Hangs
});

// Request-Interceptor: Auth Token aus localStorage anhaengen
client.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    if (config.headers && typeof config.headers.set === 'function') {
      config.headers.set('Authorization', `Bearer ${token}`);
    } else {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  if (import.meta.env.DEV) {
    console.log(`[API] ${config.method?.toUpperCase()} ${config.url}`);
  }

  return config;
});

// Response-Interceptor: bei 401 = Token kaputt → Logout + Login
// (Kein Auto-Refresh — zu komplex, zu viele Edge-Cases. Senior-Move:
//  einfach halten. Token gilt 15 Min, User loggt halt nochmal ein.)
client.interceptors.response.use(
  (response) => response,
  (error) => {
    // Optimistic Locking: 409 als User-sichtbare Warnung
    if (error.response?.status === 409) {
      const msg = error.response?.data?.message || 'Inhalt wurde zwischenzeitlich geaendert. Bitte neu laden.';
      if (typeof window !== 'undefined') window.alert(msg);
      return Promise.reject(error);
    }

    // 401 = abgelaufener / ungueltiger Token → komplett ausloggen
    if (error.response?.status === 401) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/login')) {
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export default client;
